module.exports = __webpack_public_path__ + "static/media/md.7e4c0d86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/md.svg
// module id = 184
// module chunks = 0